import React from 'react';
import '../css/queincluye.scss';
import Breadcrumbs from './Breadcrumbs';

import buffetImg from '../assets/images/mascota.jpg'; // reemplaza por tu imagen
import Footer from './Footer';

const foodBenefits = [
  'Comida tipo Buffet (Platillo fuerte, guarniciones y postre)',
  'Servicio de café matutino incluido',
  'Alternativas para niños y opciones veganas'
];

const schedules = [
  {
    route: 'La Paz – Mazatlán',
    weekday: '3:30 pm a 7:30 pm',
    weekend: '—'
  },
  {
    route: 'Mazatlán – La Paz',
    weekday: '2:00 pm a 4:30 pm',
    weekend: '—'
  },
  {
    route: 'La Paz – Topo',
    weekday: '22:00 a 0:30 pm',
    weekend: '21:30 a 23:30 pm'
  },
  {
    route: 'Topo – La Paz',
    weekday: '22:00 a 0:30 pm',
    weekend: '21:30 a 23:30 pm'
  }
];

export default function Incluye() {
  return (
    <>
      {/* =========================
          HERO
      ========================= */}

      <section className="entretenimiento">

        <div className="entretenimiento-hero">

          <div className="overlay"></div>

          <div className="container">

            <div className="hero-content">

              <div
                style={{
                  marginTop: '4rem',
                  color: '#fff'
                }}
              >
                <Breadcrumbs />
              </div>

              <h1>
                Tu Experiencia a Bordo
              </h1>

              <p>
                Disfruta de beneficios diseñados para transformar un
                traslado en un viaje memorable.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =========================
          INCLUYE
      ========================= */}

      <section className="incluye">

        <div className="container">

          <div className="bento-grid">


            {/* =====================
                ALIMENTOS
            ===================== */}

            <div className="card food-card">

              <div className="food-content">

                <div className="icon-box">

                  <span className="material-symbols-outlined">
                    restaurant
                  </span>

                </div>

                <h3>
                  Alimentos y Bebidas
                </h3>

                <p>
                  Deléitate con nuestro servicio de alimentos de cortesía
                  durante tu travesía. Desde un buffet completo hasta
                  opciones ligeras de café para iniciar el día.
                </p>

                <ul>

                  {foodBenefits.map((item, index) => (

                    <li key={index}>

                      <span className="material-symbols-outlined">
                        check_circle
                      </span>

                      <span>
                        {item}
                      </span>

                    </li>

                  ))}

                </ul>

              </div>


              <div className="food-image">

                <img
                  src={buffetImg}
                  alt="Buffet Baja Ferries"
                />

              </div>

            </div>


            {/* =====================
                EQUIPAJE
            ===================== */}

            <div className="card luggage-card">

              <div className="luggage-content">

                <div className="icon-box">

                  <span className="material-symbols-outlined">
                    luggage
                  </span>

                </div>

                <h3>
                  Equipaje Sin Costo
                </h3>

                <p>
                  No te preocupes por el peso. Incluimos una generosa
                  política de equipaje para que lleves todo lo necesario.
                </p>

                <div className="luggage-number">

                  <span>
                    5
                  </span>

                  <small>
                    Maletas de
                  </small>

                </div>

                <div className="weight">

                  25 <small>kg c/u</small>

                </div>

              </div>

              <div className="bubble"></div>

            </div>


            {/* =====================
                ASIENTO
            ===================== */}

            <div className="card lounge-card">

              <div className="icon-box">

                <span className="material-symbols-outlined">
                  chair
                </span>

              </div>

              <h3>
                Salón de Pasajeros
              </h3>

              <p>
                Tu boleto incluye un asiento (sujeto a disponibilidad)
                cómodo en nuestras amplias áreas de descanso. Disfruta
                de la vista al mar o relájate con entretenimiento a bordo.
              </p>

            </div>


            {/* =====================
                HORARIOS
            ===================== */}

            <div className="card schedule-card">

              <div className="schedule-header">

                <h3>
                  Horarios de Alimentos
                </h3>

                <span className="badge">
                  Servicio de Cortesía, al a bordar
                </span>
                

              </div>


              <div className="table-wrapper">

                <table>

                  <thead>

                    <tr>

                      <th>
                        Ruta
                      </th>

                      <th>
                        Lunes a Viernes
                      </th>

                      <th>
                        Fines de Semana
                      </th>

                    </tr>

                  </thead>


                  <tbody>

                    {schedules.map((item, index) => (

                      <tr key={index}>

                        <td>
                          {item.route}
                        </td>

                        <td>
                          {item.weekday}
                        </td>

                        <td>
                          {item.weekend}
                        </td>

                      </tr>

                    ))}

                  </tbody>

                </table>

              </div>


              <p className="note">
                * Los horarios están sujetos a cambios según condiciones
                de navegación.
              </p>

            </div>


          </div>

        </div>

      </section>


      <Footer />

    </>
  );
}